import { FormMode } from '../../form/helper/FormModeProvider';
import { DemandDetailPage } from './DemandDetailPage';

export const DemandReadPage = () => {
  return <DemandDetailPage mode={FormMode.READ} />;
};
